import styled from 'styled-components';

export const FormContainer = styled.div`
  max-width: 385px;
  width    : 90%;
`;

export const InputFieldWrapper = styled.div`
  margin-top: 28px;
`;